<template>
  <section class="figer-wrapper   pb-5 mt-5  about-jq">
        <div class="  mt-5">
            <div class="container">
                <div class="row  ">
                    <div class="col-md-7 col-12  text-333 text-left clearfix">
                        <img :src="aboutTitleImg" class="mb-3 mb-sm-0" />
                        <p class="text">
                            机巧科技成立于2020年是一家基于人工智能和大数据技术驱动，以企业智能工商财务服务为核心的入库科技型企服机构，服务对象为亿级体量的初创中小微企业，目前身为中科院、蚂蚁金服及多家银行金融机构的战略合作伙伴。
                        </p>
                        <p class="">
                            机巧科技致力于通过数字神经网络学习、智能RPA、NLP自然语义处理技术、智能语音交互、联邦算法数据脱敏、知识图谱爬虫、企业财务大数据风控等尖端互联网和AI技术，为初创小微企业提供标准化、无纸化、智能化、自动化、可视化的智慧工商财务SaaS工具。
                        </p>
                        <p class="more"><a class="text-044fff" href="http://pkt.zoosnet.net/LR/Chatpre.aspx?id=PKT58642380&lng=cn" target="_blank">了解机巧>></a> </p>
                    </div>
                    <div class="col-md-5 col-12  text-333 text-center clearfix">
                        <img :src="about01Img" class="img-fluid mb-3 mb-sm-0" />
                    </div>

                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
  name: 'Company',
  data () {
    return {
      aboutTitleImg: require('../../../assets/image/img-about-title-01.png'),
      about01Img: require('../../../assets/image/img-about-01.png')
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/about/components/Company.vue